import { render, staticRenderFns } from "./overPrice.vue?vue&type=template&id=5dace6d4&"
import script from "./overPrice.vue?vue&type=script&lang=js&"
export * from "./overPrice.vue?vue&type=script&lang=js&"
import style0 from "./overPrice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports